/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useStateValue } from "../StateProvider";
// import { ShowProfileHover } from "./ShowProfileHover";
import "./Header.css";
import mainLogo from "../img/main_logo_png.svg";
import HomeIcon from "@mui/icons-material/MultilineChartRounded";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
// import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
//import img from "../img/logo.svg";
function Header() {
  // eslint-disable-next-line no-unused-vars
  const [{ user }] = useStateValue();

  useEffect(() => {
    const btnToggle = document.querySelector("#themeToggle i");
    const theme = localStorage.getItem("theme");

    if (theme === "light") {
      btnToggle.classList.add("fa-sun");
      btnToggle.classList.remove("fa-moon");
      document.querySelector("body").classList.add(theme);
    }

    btnToggle.addEventListener("click", () => {
      if (btnToggle.classList.contains("fa-moon")) {
        btnToggle.classList.add("fa-sun");
        btnToggle.classList.remove("fa-moon");
        localStorage.setItem("theme", "light");
      } else {
        btnToggle.classList.add("fa-moon");
        btnToggle.classList.remove("fa-sun");
        localStorage.clear();
      }
      document.querySelector("body").classList.toggle("light");
    });
  }, []);
//   showMessage(() => {
//     toast({
//         type: 'info',
//         icon: 'info',
//         title: 'Coming soon!',
//         description: 'I am working really hard to implement this feature asap. for now you can use the app. Chick here to install',
//         animation: 'bounce',
//         time: 5000,
//         onClose: () => alert('you close this toast'),
//         onClick: () => window.open(
//           "https://play.google.com/store/apps/details?id=org.jhm69.battle_of_quiz"
//         ),
//         onDismiss: () => alert('you have dismissed this toast')
//     });
// }, 5000);

  return (
    
    <div className="header">
      <div className="">
        <Link className="link headerTitle" to="/">
          <img src={mainLogo} className="headLogo" />
        </Link>
      </div>
      <div className="headerSearchContainer">
        <input
          className="headerSearchInput"
          type="text"
          placeholder="Search post or user"
        />
        <SearchRoundedIcon className="search headerSearchIcon" />
        <div id="themeToggle" className="headerSearchIcon">
          <i className="far fa-moon"></i>
        </div>
      </div>

      <div className="break"></div>

      <div className="headerNavContainer">
        <Link to="/" className="link headerOptionBasket">
          <div className="headerOptionBasket">
            <HomeIcon />
          </div>
        </Link>

        <Link
          target="_blank"
          to="/install"
          className="link headerOptionBasket"
          onClick={(event) => {
            event.preventDefault();
            window.open(
              "https://play.google.com/store/apps/details?id=org.jhm69.battle_of_quiz"
            );
          }}
        >
          <div className="headerOptionBasket">
            <BoltOutlinedIcon />
          </div>
        </Link>

        <Link className="link headerOptionBasket">
          <div className="headerOptionBasket">
            <ForumOutlinedIcon />
          </div>
        </Link>

        <Link className="link headerOptionBasket">
          <div className="headerOptionBasket">
            <NotificationsNoneOutlinedIcon />
          </div>
        </Link>

        <Link
          to={!user ? "/login" : `/user/${user?.id}`}
          className="link headerOptionBasket"
        >
          <div className="headerOptionBasket">
            <img
              className=" headerAvatar"
              src={
                user?.image ||
                `https://firebasestorage.googleapis.com/v0/b/battle-of-quiz-be836.appspot.com/o/logo.svg?alt=media&token=757b49a1-bf7c-4c2a-b091-f4ef2ac6985c`
              }
            />
          </div>
        </Link>

        <Link className="link headerOptionBasket" to={"/post/about_app/"}>
          <div className="headerOptionBasket">
            <InfoOutlinedIcon/>
          </div>
        </Link>

      </div>
    </div>
  );
}

export default Header;
